export type GoogleReviewBranchConfig = {
    googleReviewUrl?: string;
};

export const isMultiBranchGoogleReviewSetup = (
    branches?: Record<string, GoogleReviewBranchConfig>,
): boolean => Object.keys(branches ?? {}).length > 1;

export const hasGoogleReviewUrlForTest = ({
    isMultiBranch,
    globalGoogleReviewUrl,
    branchId,
    branchReviewUrls,
}: {
    isMultiBranch: boolean;
    globalGoogleReviewUrl?: string;
    branchId?: string;
    branchReviewUrls: Record<string, string>;
}): boolean => {
    const hasGlobalUrl = !!globalGoogleReviewUrl?.trim();
    const hasSelectedBranchUrl = !!(branchId && branchReviewUrls[branchId]?.trim());
    const hasAnyBranchUrl = Object.values(branchReviewUrls).some(url => !!url.trim());

    if (!isMultiBranch) {
        return hasGlobalUrl || hasSelectedBranchUrl || hasAnyBranchUrl;
    }

    return hasSelectedBranchUrl;
};
